
import { useState, useEffect } from 'react';


export const useScrollProgress = (ref) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const element = ref.current;

    const handleScroll = () => {
      if (!element) return;

      const { top, height } = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      
      const elementTopInView = Math.max(0, viewportHeight - top);
      const visibleHeight = Math.min(elementTopInView, height);

      
      const scrollProgress = Math.min(1, Math.max(0, visibleHeight / height));
      setProgress(scrollProgress);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); 

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [ref]);

  return progress;
};